import React, { memo } from 'react';
export function Hero() {
  return <section className="relative pt-4 pb-8 md:pt-8 md:pb-12 overflow-hidden" aria-label="Presentación del Sistema Maestro de Aluminio" style={{
    contain: 'layout'
  }} data-id="element-119">
      <div className="container mx-auto px-4 relative z-10" data-id="element-120">
        <div className="flex flex-col items-center" data-id="element-121">
          <div className="flex-1 text-center max-w-4xl" data-id="element-122">
            <h1 className="md:text-7xl font-bold mb-6 text-[36px]" data-id="element-123">
              <span className="block bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[#D4A943] md:text-3xl mb-2 text-[18px]" data-id="element-124">
                🔧 SISTEMA MAESTRO DE ALUMINIO
              </span>
              Todo tu taller de aluminio. Listo. Desde hoy.
            </h1>

            <div className="mb-8 relative" data-id="element-125">
              <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full z-0 pointer-events-none" data-id="element-126"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hfD1CruJ8XYnedNYQnq6SX/Diseno_sin_titulo_(3).png" alt="Sistema Maestro de Aluminio — El sistema N°1 para carpinteros y armadores" className="mx-auto block w-[320px] md:w-[480px] relative z-10 drop-shadow-2xl" width={480} height={480} fetchPriority="high" decoding="async" data-id="element-127" />
            </div>

            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-128">
              Tablas, planos, mecanizados, instalación y presupuestos listos.
              Sin improvisar ni perder material.
            </p>

            <button onClick={() => {
            const target = document.getElementById('cta-comprar');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-colors uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)]" data-id="element-129">
              🔩 → QUIERO MI SISTEMA MAESTRO AHORA
            </button>

            <div className="flex flex-wrap justify-center gap-4 mt-8 mb-6" role="list" aria-label="Características principales" data-id="element-130">
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-131">
                <span className="text-2xl" aria-hidden="true" data-id="element-132">
                  📄
                </span>
                <span className="font-medium text-sm" data-id="element-133">100% PDF</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-134">
                <span className="text-2xl" aria-hidden="true" data-id="element-135">
                  ⚡
                </span>
                <span className="font-medium text-sm" data-id="element-136">Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-137">
                <span className="text-2xl" aria-hidden="true" data-id="element-138">
                  🇦🇷
                </span>
                <span className="font-medium text-sm" data-id="element-139">
                  Línea Herrero → Módena
                </span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-140">
                <span className="text-2xl" aria-hidden="true" data-id="element-141">
                  🔧
                </span>
                <span className="font-medium text-sm" data-id="element-142">
                  Todas las tipologías
                </span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-143">
              <div className="flex items-center gap-2" data-id="element-144">
                <span className="text-gold" aria-hidden="true" data-id="element-145">
                  🛡️
                </span>
                <span data-id="element-146">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-147">
                <span className="text-gold" aria-hidden="true" data-id="element-148">
                  🔒
                </span>
                <span data-id="element-149">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-150">
                <span className="text-gold" aria-hidden="true" data-id="element-151">
                  💳
                </span>
                <span data-id="element-152">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}